import { useQuery } from '@tanstack/react-query'
import { RequestDocumentSource } from '@omnea-app/documents/documentsFrontendClient'
import { DocumentsHttpClient } from '@omnea-app/documents/documentsHttpClient'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { classificationRefetchInterval } from './classificationRefetchInterval'
import { inFlightReviewRefetchInterval, combineRefetchIntervals } from './refetchIntervals'

export const GetRequestDocumentsQueryKey = 'GetRequestDocuments'

export const getRequestDocumentsQueryKey = (requestId: string, source?: RequestDocumentSource) =>
  source ? [GetRequestDocumentsQueryKey, requestId, source] : [GetRequestDocumentsQueryKey, requestId]

export const useGetRequestDocuments = (requestId: string, source?: RequestDocumentSource) => {
  const { getToken } = useAuthenticatedUser()
  return useQuery({
    // The source-scoped lists and the general list are disjoint, so they must not share a cache entry.
    queryKey: getRequestDocumentsQueryKey(requestId, source),
    queryFn: async () => {
      const token = await getToken()
      const documentsClient = new DocumentsHttpClient({ authorization: token })
      const { data, error } = await documentsClient.GET('/request/{requestId}/documents', {
        params: {
          path: { requestId },
          query: {
            source,
          },
        },
      })
      throwIfApiError(error)
      return data
    },
    refetchInterval: (query) =>
      combineRefetchIntervals(classificationRefetchInterval(query.state.data), inFlightReviewRefetchInterval(query.state.data)),
  })
}
